import React from "react";
import { Link } from "react-router-dom";
import moment from "moment";

class Footer extends React.Component {
  render() {
    return (
      <footer className="pt-3 footer_detail">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="mt-4 footerul">
                {/*<Link to="/about-us">About Us</Link>*/}
                <Link to="/faq">FAQ</Link>
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/termsofuse">Terms and Conditions</Link>
                <Link to="/contact-us">Contact Us</Link>
                <Link to="/connect">Let's Work Together!</Link>
              </div>
            </div>
          </div>
          <div className="footer_divider mb-0" />
          <div className="row pt-4 pb-4">
            <div className="col-lg-12">
              <div className="clearfix">
                <div className="float-left float_none">
                  <p className="copy-rights mb-0">
                    &copy; {moment().format("YYYY")} MightyWifi. All rights reserved.
                  </p>
                </div>
                <div className="float-right float_none">
                  <ul className="list-inline fot_social mb-0">
                    <li className="list-inline-item">
                      <a href="https://www.facebook.com/Mightywifi-101775645858664" className="social-icon text-muted">
                        <i className="mdi mdi-facebook" />
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href="https://twitter.com/mightywifi" className="social-icon text-muted">
                        <i className="mdi mdi-twitter" />
                      </a>
                    </li>
                    <li className="list-inline-item">
                      <a href="https://www.instagram.com/themightywifi/" className="social-icon text-muted">
                        <i className="mdi mdi-instagram" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/layout/Footer.js